import React, { useState } from "react";
import OrderCard from "./OrderCard";
import { orderHistoryTabData } from "../../utils/staticData";
import { areArraysEqual } from "../../utils/function.utils";

const Orders = (props) => {
  const { editData } = props;

  const [tab, setTab] = useState([
    { name: "در حال پردازش", id: "pending", color: "#FFCF0E" },
    { name: "ارسال شده", id: "posted", color: "#22A137" },
    { name: "در حال ارسال", id: "delivered", color: "#1E67BF" },
    { name: "در انتظار پرداخت", id: "waiting_payment", color: "#FE9D00" },
  ]);

  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("master"); // فیلتر نوع سفارش

  const tabClickHandler = (item) => {
    setTab(item.value);
  };

  const getOrderCountForTab = (tabValues) => {
    return editData?.data?.orders?.filter(
      (orderItem) =>
        tabValues.some((statusObj) => statusObj.id === orderItem.status) &&
        (typeFilter === "all" || orderItem?.orderable_type === typeFilter) &&
        (orderItem?.vehicle_tip?.title_model
          ?.toLowerCase()
          ?.includes(search.toLowerCase()) ||
          orderItem?.code?.toString().includes(search)),
    ).length;
  };

  const filteredOrders = editData?.data?.orders
    ?.filter((item) => tab.some((tabItem) => tabItem.id === item.status))
    ?.filter(
      (item) =>
        (item?.vehicle_tip?.title_model
          ?.toLowerCase()
          ?.includes(search.toLowerCase()) ||
          item?.code?.toString().includes(search)) &&
        (typeFilter === "all" || item?.orderable_type === typeFilter),
    );

  return (
    <>
      <span>تاریخچه سفارشات</span>

      {/* select نوع سفارش */}
      <select
        value={typeFilter}
        onChange={(e) => setTypeFilter(e.target.value)}
        className="w-full p-2 rounded border border-gray-300 my-2 text-right"
        dir="rtl"
      >
        {/*<option value="all">همه نوع سفارش‌ها</option>*/}
        <option value="master">کارشناسی</option>
        <option value="periodic_service">سرویس دوره‌ای</option>
        <option value="battery">باطری</option>
        <option value="advertisement">آگهی</option>
      </select>

      {/* input جستجو */}
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="جستجو در سفارشات..."
        className="w-full p-2 rounded border border-gray-300 my-4 text-right"
        dir="rtl"
      />

      {/* تب‌ها */}
      <div className="shadow-custom1 flex justify-around text-14 font-medium rounded-8 overflow-hidden">
        {orderHistoryTabData.map((item) => (
          <div
            className={`flex items-center justify-center gap-1 cursor-pointer py-[14px] flex-1 ${
              areArraysEqual(item.value, tab)
                ? "text-[#F66B34] border-b border-[#F66B34]"
                : "text-[#6D6D6D]"
            }`}
            key={item.value}
            onClick={() => tabClickHandler(item)}
          >
            <span className={"text-[14px]"}>{item.label}</span>
            <span
              className={`${
                areArraysEqual(item.value, tab)
                  ? "bg-[#F66B34]"
                  : "bg-[#FCCAAC]"
              } text-white font-medium text-[12px] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center`}
            >
              {getOrderCountForTab(item.value)}
            </span>
          </div>
        ))}
      </div>

      {/* نمایش سفارش‌ها */}
      <div className="w-full h-[700px] overflow-y-scroll flex flex-col my-2 gap-4">
        {filteredOrders?.map((item, index) => (
          <OrderCard
            data={item}
            tabStatus={tab.find((tabItem) => tabItem.id === item.status)}
            key={index}
            orderName={typeFilter}
          />
        ))}
      </div>
    </>
  );
};

export default Orders;
